export const PAGE_LIMIT = 20;
export const MESSAGE_TYPE_FILE = "FILE";
export const MESSAGE_FILE_TYPE_IMAGES = "Images";

export const formatMessageHistoryDateTime = (createdAt: string): string => {
  return new Date(createdAt).toLocaleString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};
